import { sb } from './supabase.ts';

export async function handleIidSearch(iidValue: string): Promise<void> {
  const iid = iidValue.trim();
  if (!iid) return;

  const status = document.getElementById('searchStatus');
  if (status) status.textContent = 'Searching...';

  try {
    const { data, error } = await sb
      .from('student_database')
      .select('iid')
      .eq('iid', Number(iid))
      .single();

    if (error || !data) {
      if (status) status.textContent = 'ID not found';
      alert('IID not found in database');
      return;
    }

    if (status) status.textContent = 'Found!';
    
    // Use the new path-based route
    const url = `/edit_details?iid=${encodeURIComponent(iid)}`;
    window.open(url, '_blank', 'noopener');

  } catch (err) {
    console.error('IID search error:', err);
    if (status) status.textContent = 'Error';
  }
}

export function setupIidSearch(inputId: string, buttonId: string): void {
  const input = document.getElementById(inputId) as HTMLInputElement;
  const button = document.getElementById(buttonId);

  if (!input || !button) return;

  button.addEventListener('click', () => handleIidSearch(input.value));
  input.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') handleIidSearch(input.value);
  });
}
